import React from "react";
import { Link, NavLink } from "react-router-dom";
import { ArrowRight, HeartPulse, LockKeyhole, MessagesSquare, Users } from "lucide-react";
import { useAuth } from "../AuthContext";

export const COMMUNITY_SECTIONS = [
  {
    id: "discussions", to: "/discussions", title: "Обсуждения", icon: MessagesSquare,
    description: "Профессиональное общение с коллегами в каналах по специальностям.",
    features: ["Обсуждайте профессиональные вопросы и материалы портала.", "Выбирайте каналы по своим интересам и специальности.", "Обменивайтесь опытом и задавайте вопросы коллегам."],
    note: "Чтение обсуждений доступно после входа. Чтобы писать сообщения, подтвердите адрес электронной почты.",
  },
  {
    id: "second-opinion", to: "/second-opinion", title: "Второе мнение", icon: HeartPulse,
    description: "Отправьте запись ЭКГ, Холтера или СМАД на разбор специалисту.",
    features: ["Опишите вопрос и приложите обезличенные записи исследования.", "Следите за статусом обращения в своём кабинете раздела.", "Просматривайте заключение специалиста по вашему обращению."],
    note: "Обращения и приложенные записи доступны участникам разбора. Перед отправкой удалите персональные данные пациента.",
  },
  {
    id: "doctors", to: "/doctors", title: "Справочник коллег", icon: Users,
    description: "Найдите коллегу по имени или специальности и познакомьтесь с его профессиональным профилем.",
    features: ["Ищите врачей по имени и специальности.", "Знакомьтесь с профессиональными сведениями в профилях коллег.", "Настройте видимость своего профиля в справочнике."],
    note: "Список коллег доступен только после входа. Каждый участник управляет видимостью своего профиля.",
  },
];

function CommunityNav() {
  return (
    <nav className="community-nav" aria-label="Разделы сообщества">
      <NavLink to="/community" end>Сообщество</NavLink>
      {COMMUNITY_SECTIONS.map(item => <NavLink key={item.id} to={item.to}>{item.title}</NavLink>)}
    </nav>
  );
}

export default function Community() {
  const { isLoggedIn } = useAuth();
  return (
    <section>
      <h1 className="section-title">Сообщество</h1>
      <p className="community-intro">Общайтесь с коллегами, обсуждайте профессиональные вопросы и обращайтесь за вторым мнением.</p>
      {!isLoggedIn && <p className="community-access"><LockKeyhole size={16} aria-hidden="true" /> Разделы сообщества доступны после входа или регистрации.</p>}
      <div className="community-grid">
        {COMMUNITY_SECTIONS.map(item => (
          <Link key={item.id} to={item.to} className="community-card">
            <item.icon className="community-card-icon" size={26} aria-hidden="true" />
            <h2>{item.title}</h2>
            <p>{item.description}</p>
            <span className="community-card-action">{isLoggedIn ? "Перейти" : "Подробнее"}<ArrowRight size={16} aria-hidden="true" /></span>
          </Link>
        ))}
      </div>
    </section>
  );
}

export function CommunitySection({ section, children, onLoginRequest, onRegisterRequest }) {
  const { isLoggedIn, loading } = useAuth();
  const item = COMMUNITY_SECTIONS.find(entry => entry.id === section);
  return (
    <>
      <CommunityNav />
      {loading ? <p role="status">Загрузка…</p> : isLoggedIn ? children : (
        <section className="community-gate">
          <span className="community-access"><LockKeyhole size={16} aria-hidden="true" /> Требуется вход</span>
          <h1 className="section-title"><item.icon size={24} aria-hidden="true" />{item.title}</h1>
          <p className="community-intro">{item.description}</p>
          <ul className="community-features">{item.features.map(feature => <li key={feature}>{feature}</li>)}</ul>
          <p className="community-note">{item.note}</p>
          <div className="community-auth-actions">
            <button type="button" className="auth-submit-btn" onClick={onRegisterRequest}>Зарегистрироваться</button>
            <button type="button" className="community-login-btn" onClick={onLoginRequest}>Войти</button>
          </div>
          <p className="community-return-note">После входа вы вернётесь в этот раздел.</p>
        </section>
      )}
    </>
  );
}
